/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

export const SA_PROGRAM_CSV_FILE_UPLOAD_RESET = "SA_PROGRAM_CSV_FILE_UPLOAD_RESET";
export const SA_PROGRAM_CSV_FILE_UPLOAD = "SA_PROGRAM_CSV_FILE_UPLOAD";
export const SA_PROGRAM_CSV_FILE_UPLOAD_SUCCESS = "SA_PROGRAM_CSV_FILE_UPLOAD_SUCCESS";
export const SA_PROGRAM_CSV_FILE_UPLOAD_FAIL = "SA_PROGRAM_CSV_FILE_UPLOAD_FAIL";
export const SA_PROGRAM_CSV_FILE_UPLOAD_BAD_REQUEST = "SA_PROGRAM_CSV_FILE_UPLOAD_BAD_REQUEST";

export const SA_PROGRAM_CSV_FILE_SUBMIT = "SA_PROGRAM_CSV_FILE_SUBMIT";
export const SA_PROGRAM_CSV_FILE_SUBMIT_SUCCESS = "SA_PROGRAM_CSV_FILE_SUBMIT_SUCCESS";
export const SA_PROGRAM_CSV_FILE_SUBMIT_FAIL = "SA_PROGRAM_CSV_FILE_SUBMIT_FAIL";
